export default "__VITE_ASSET__bCB2uqRi__"